import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {WPUserArray} from '../../types/WPUserArray';
import {UrlBuilderService} from '../../services/url-builder.service';

interface AuthorToDisplay extends WPUserArray {
  routerLink: string[];
}

@Component({
  selector: 'app-author-block',
  templateUrl: './author-block.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block border-t border-grey-10',
  },
})
export class AuthorBlockComponent {
  publishDate = input<string>(null);
  updateDate = input<string>(null);
  author = input<WPUserArray[]>(null);
  authorName = input<string>(null);
  factChecker = input<string>(null);
  protected readonly hasAuthorName = computed(() => this.authorName() != null && this.authorName() !== '');
  protected readonly hasFactChecker = computed(() => this.factChecker() != null && this.factChecker() !== '');
  protected readonly hasAuthors = computed(() => this.authorsToDisplay().length > 0);
  private readonly urlBuilder = inject(UrlBuilderService);
  protected readonly authorsToDisplay = computed<AuthorToDisplay[]>(() => {
    if (!this.author()) {
      return [];
    }
    return (
      this.author()?.map((item) => ({
        ...item,
        routerLink: this.urlBuilder.CreateAuthorRouterLink(item.nickname),
      })) || []
    );
  });

  trackById(index: number, item: WPUserArray): number | null {
    return item?.ID || null;
  }
}
